import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/dataService.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {

    static componentName = 'AboutComponent';
    post: any;

    constructor(
        private dataService: DataService,
    ) {}

    getPost(): void {
        this.dataService.getPost('om-oss')
            .subscribe(res => this.post = res);
    }

    ngOnInit() {
        this.getPost();

        setTimeout(() => {
            if (document.querySelectorAll('.about-hero').length) {
                document.querySelectorAll('.about-hero')[0].classList.add('show');
            }
        }, 1300);
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/about/about.component.ts